import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const BlogSection = () => {
  const blogs = [
    {
      id: 1,
      title: 'All Types of Aluminium Glass Office Partition',
      content: 'Anjali Enterprises specializes in all types of aluminium glass office partitions. We provide high-quality and durable partitions that add elegance and efficiency to your office spaces.',
      image: '/images/keyword/1.jpg',
      link: '/Aluminium-Glass-Office-Partition-Services-in-Pune',
    },
    {
      id: 2,
      title: 'All Types of Toughened Glass Work',
      content: 'We provide top-notch toughened glass work that is perfect for a range of applications, ensuring safety and clarity. Whether for windows, partitions, or doors, we ensure precision in every installation.',
      image: '/images/keyword/2.jpg',
      link: '/Toughened-Glass-Work-Services-in-Pune',
    },
    {
      id: 3,
      title: 'Door Partition Solutions',
      content: 'Our door partitions are custom-designed to meet your needs, enhancing your space with style and functionality. We use high-quality materials for long-lasting performance.',
      image: '/images/keyword/3.jpg',
      link: '/Door-Partition-Services-in-Pune',
    },
    {
      id: 4,
      title: 'ACP Cladding Panel Installation',
      content: 'We specialize in ACP cladding panel installation, offering modern, sleek, and durable facades for buildings. Our panels are perfect for both commercial and residential projects.',
      image: '/images/keyword/4.jpg',
      link: '/ACP-Cladding-Panel-Installation-Services-in-Pune',
    },
    {
      id: 5,
      title: 'Sound Proof Glass Window Installation',
      content: 'Our soundproof glass windows help reduce noise pollution, making them ideal for offices, homes, and studios. Enjoy peace and quiet with our expertly installed soundproofing solutions.',
      image: '/images/keyword/6.jpg',
      link: '/Soundproof-Glass-Window-Installation-Services-in-Pune',
    },
    {
      id: 6,
      title: 'MS Fabrication Work: Doors, Shades, and Grills',
      content: 'Anjali Enterprises is known for its high-quality MS fabrication work. From doors and shades to grills and industrial structures, we deliver outstanding craftsmanship tailored to your specific needs.',
      image: '/images/keyword/9.jpg',
      link: '/MS-Fabrication-Door-Installation-Services-in-Pune',
    },
  ];

  return (
    <div>
      <Helmet>
        {/* Meta tags */}
      </Helmet>

      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-fluid w-100" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className="text-white">Blog</h1>
        </div>
      </div>

      <section className="blog-section py-5">
        <div className="container">
          <div className="row">
            {blogs.map((blog) => (
              <div className="col-md-4 mb-4" key={blog.id}>
                <div className="card shadow-sm border-light rounded h-100">
                  <img src={blog.image} alt={blog.title} className="card-img-top rounded-top" />
                  <div className="card-body">
                    <h5 className="card-title text-dark font-weight-bold">{blog.title}</h5>
                    <p className="card-text text-muted">{blog.content}</p>
                    {/* Use React Router Link to navigate to the blog detail page */}
                    <Link to={blog.link} className="btn btn-primary mt-3">
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogSection;
